
<template>
  <vxe-pager
    class="cml-pagination"
    background
    size="small"
    :current-page="pageNo"
    :page-size="pageSize"
    :total="total"
    :page-sizes="pageSizes"
    :layouts="layouts"
    @page-change="handlePageChange"
  >
  </vxe-pager>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    name: {
      type: String,
      default: '',
    },
    pageNo: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    layouts: {
      type: Array,
      default() {
        return [
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ];
      },
    },
  },
  watch: {},
  methods: {
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.$emit('handlePageChange', {
        pageSize: pageSize,
        pageNo: currentPage
      })
    },
  },
};
</script>
<style lang="less" scoped>
</style>
